import { render, staticRenderFns } from "./EvbModal.vue?vue&type=template&id=68061030&"
import script from "./EvbModal.vue?vue&type=script&lang=js&"
export * from "./EvbModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports